var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AreaFilter from '@/components/SummaryFilters/AreaFilter/AreaFilter.vue';
import ExpansionPanelDialog from '@/components/dialog/ExpansionPanelDialog/ExpansionPanelDialog.vue';
import { RpcClient } from '@/http';
import { GraduationProfile } from '@/models/GraduationProfile';
import SelectGraduationProfileDialog from '@/components/dialog/SelectGraduationProfileDialog/SelectGraduationProfileDialog.vue';
import ErrorHandler from '@/support/ErrorHandler';
let AssignGraduationProfileDialog = class AssignGraduationProfileDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.isFetchingTableData = false;
        this.selectedArea = '';
        this.tableItems = [];
        this.tablePagination = {
            rowsPerPage: -1,
        };
        this.graduationProfiles = [];
        this.selectedStudent = null;
        this.selectedGraduationProfile = null;
        this.selectGraduationProfileDialogVisible = false;
        this.selectGraduationProfileDialogDescription = '';
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        // await this.fetchGraduationProfiles();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onClose() {
        this.$emit('close');
    }
    onEditGraduationProfileForAll() {
        this.selectGraduationProfileDialogDescription = this.$tc('Select a graduation profile for all selected students.');
        this.selectGraduationProfileDialogVisible = true;
    }
    onEditGraduationProfile(item) {
        this.selectGraduationProfileDialogDescription = this.$tc('Edit the graduation profile for the selected student.');
        this.selectedGraduationProfile = item.exit_profile;
        this.selectedStudent = item;
        this.selectGraduationProfileDialogVisible = true;
    }
    onAddGraduationProfile(item) {
        this.selectGraduationProfileDialogDescription = this.$tc('Add a graduation profile for the selected student.');
        this.selectedStudent = item;
        this.selectGraduationProfileDialogVisible = true;
    }
    onCloseSelectGraduationProfileDialog() {
        this.selectGraduationProfileDialogVisible = false;
        this.selectedStudent = null;
        this.selectedGraduationProfile = null;
    }
    onGraduationProfileSelected(payload) {
        this.selectGraduationProfileDialogVisible = false;
        if (this.selectedStudent === null) {
            this.updateGraduationProfileForAllStudents(payload);
        }
        else {
            this.updateGraduationProfileForStudent(this.selectedStudent.id, payload);
            this.selectedStudent = null;
            this.selectedGraduationProfile = null;
        }
    }
    // #endregion
    // #region Class methods
    getHasExitProfile(item) {
        return !!item.exit_profile && Object.keys(item.exit_profile).length > 0;
    }
    setTableItems(data) {
        this.tableItems = Object.keys(data).map((studentKey) => {
            const item = data[studentKey];
            return {
                id: studentKey,
                name: item.name,
                exit_profile: Object.values(item.exit_profiles)[0],
            };
        });
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchCurrentlyAssignedGraduationProfiles() {
        this.isFetchingTableData = true;
        try {
            const response = await new RpcClient().execute('get-exit-profile-users', {
                area: this.selectedArea,
                users: this.students.map((student) => student.id),
            });
            this.setTableItems(response);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isFetchingTableData = false;
        }
    }
    async updateGraduationProfileForAllStudents(payload) {
        const graduationProfile = this.graduationProfiles.find((profile) => profile.id === payload.graduationProfile);
        const studentIds = this.students.map((student) => student.id);
        if (!graduationProfile || !studentIds.length) {
            return;
        }
        this.isLoading = true;
        try {
            await graduationProfile.attachStudents(studentIds, payload.disableExistingGoals);
            await this.fetchCurrentlyAssignedGraduationProfiles();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    async updateGraduationProfileForStudent(studentId, payload) {
        const graduationProfile = this.graduationProfiles.find((profile) => profile.id === payload.graduationProfile);
        if (!graduationProfile) {
            return;
        }
        this.isLoading = true;
        try {
            await graduationProfile.attachStudents([studentId], payload.disableExistingGoals);
            await this.fetchCurrentlyAssignedGraduationProfiles();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    async fetchGraduationProfiles() {
        try {
            this.graduationProfiles = await new GraduationProfile().filter({ area: this.selectedArea }).limit(50).all();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get tableHeaders() {
        return [
            {
                text: this.$tc('Student'),
                align: 'left',
                sortable: false,
                value: 'name',
            },
            {
                text: this.$tc('Graduation profile'),
                align: 'left',
                sortable: false,
                value: 'exit_profile',
            },
            {
                text: '',
                class: 'icon-column',
                align: 'left',
                sortable: false,
                value: 'actions',
            },
        ];
    }
    get expansionPanelOptions() {
        return {
            title: this.$tc('Manage graduation profiles'),
            description: this.$tc('Select the area for which you want to change the graduation profile and then update the profile.'),
            panels: [
                {
                    label: `1. ${this.$tc('Select area')}`,
                    slotName: 'panel1',
                    isOpen: true,
                    disabled: false,
                },
                {
                    label: `2. ${this.$tc('Select graduation profile')}`,
                    slotName: 'panel2',
                    isOpen: false,
                    disabled: this.selectedArea.trim().length === 0,
                },
            ],
            hasSubmitButton: false,
            secondaryButtonText: this.$tc('Close'),
        };
    }
    // #endregion
    // #region @Watchers
    async onSelectedAreaChange() {
        await Promise.all([await this.fetchGraduationProfiles(), await this.fetchCurrentlyAssignedGraduationProfiles()]);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], AssignGraduationProfileDialog.prototype, "students", void 0);
__decorate([
    Watch('selectedArea'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], AssignGraduationProfileDialog.prototype, "onSelectedAreaChange", null);
AssignGraduationProfileDialog = __decorate([
    Component({
        components: {
            ExpansionPanelDialog,
            AreaFilter,
            SelectGraduationProfileDialog,
        },
    })
], AssignGraduationProfileDialog);
export default AssignGraduationProfileDialog;
// #endregion
// #region Constants
// #endregion
